// DO NOT EDIT THIS FILE!
// This file is autogenerated by the Parcel web application bundler.

import './app';
import '../../blocks/expandable-list/scripts/view';
import '../../blocks/grid/scripts/view';
import '../../blocks/hero/scripts/view';
import '../../blocks/hero-slideshow/scripts/view';
import '../../blocks/image/scripts/view';
import '../../blocks/read-more-button/scripts/view';
import '../../blocks/rich-text/scripts/view';
import '../../blocks/search-result/scripts/view';
import '../../blocks/share/scripts/view';
import '../../blocks/tab-menu/scripts/view';
import '../../blocks/video/scripts/view';
